module.exports = locationsApi;